import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-dialog',
  standalone: false,
  template: `
    @if (visible) {
      <div class="dialog-backdrop" (click)="onBackdropClick($event)">
        <div class="dialog-panel" [ngStyle]="panelStyle" (click)="$event.stopPropagation()">
          <div class="dialog-header">
            <span>{{ header }}</span>
            <button class="dialog-close-btn" (click)="close()"><i class="pi pi-times"></i></button>
          </div>
          <div class="dialog-body">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    }
  `
})
export class DialogComponent {
  @Input() visible = false;
  @Input() header = '';
  @Input() modal = true;
  @Input() width = '500px';
  @Input() style: { [key: string]: string } | undefined;

  @Output() visibleChange = new EventEmitter<boolean>();

  get panelStyle(): { [key: string]: string } {
    return { width: this.width, 'max-width': '90vw', ...this.style };
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.visible) {
      this.close();
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if (this.modal) {
      this.close();
    }
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
